import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {ThemeProvider} from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import {ApolloProvider} from '@apollo/client/react'

import '@fontsource/funnel-display/400.css'
import '@fontsource/funnel-display/500.css'
import '@fontsource/funnel-display/600.css'
import '@fontsource/funnel-display/700.css'

import './assets/styles/global.scss'

import App from './App'

import client from './graphql'
import {startMediaRelay} from './lib/mediaRelayTools'
import {finishMicrosoftSignIn, isMicrosoftSignIn} from './lib/oneDrivePicker'
import routes from './routes'
import theme from './theme'

const Root = () => (
  <StrictMode>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App routes={routes} />
      </ThemeProvider>
    </ApolloProvider>
  </StrictMode>
)

// Microsoft's sign-in comes back to this address in its own popup, which only hands the answer to
// the drive that opened it, and closes.
if (isMicrosoftSignIn()) {
  finishMicrosoftSignIn()
} else {
  startMediaRelay()

  createRoot(document.getElementById('root')).render(<Root />)
}
